<template>
  <div
    :class="`contentTab ${newStyleTabs}`"
    :style="`${noPadding ? '' : 'padding: 16px 32px;'} gap: ${
      gapTabItem || '15px'
    }`"
  >
    <div class="tabs">
      <div v-for="tab in tabs" :key="tab.name">
        <button
          :style="`font-size: ${fontSizeTitle}`"
          :class="`customTabs ${cloneTabs[tab.name] ? 'tabSelected' : ''}`"
          @click="selectTab(tab.name)"
          :ref="`refTab-${tab.name}`"
        >
          {{ tab.text }}
        </button>
      </div>
    </div>

    <div
      v-for="(tab, idx) in tabs"
      :key="tab.name"
      :hidden="!cloneTabs[tab.name]"
      class="contentItem"
      :style="`${
        idx === 0
          ? 'border-radius: 0px 5px 5px 5px!important'
          : 'border-radius: 5px!important'
      }`"
    >
      <div :hidden="!cloneTabs[tab.name]" :ref="`refTab-${tab.name}`">
        <slot :name="tab.name"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tabs: {
      type: Array,
    },
    newStyleTabs: {
      type: String,
      Default: "",
    },
    tabSelected: {
      type: Number,
    },
    actionToAlterTab: {
      type: Boolean,
    },
    fontSizeTitle: {
      type: String,
      default: "14px",
    },
    gapTabItem: {
      type: String,
      default: "15px",
    },
    noPadding: {
      type: Boolean,
      default: false,
    },
    hideBorderBottom: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      cloneTabs: {},
    };
  },
  methods: {
    selectTab(name) {
      Object.keys(this.cloneTabs).forEach((key) => {
        this.cloneTabs = {
          ...this.cloneTabs,
          [key]: key === name ? true : false,
        };
      });
    },
    handleSelectTab() {
      if (this.tabSelected > Object.keys(this.cloneTabs).length) {
        return;
      }

      const nameTab = Object.keys(this.cloneTabs).map((item) => item)[
        this.tabSelected
      ];

      this.selectTab(nameTab);
    },
  },
  mounted() {
    this.tabs.forEach((item) => {
      this.cloneTabs = { ...this.cloneTabs, [item.name]: false };
    });

    Object.keys(this.cloneTabs).forEach((item, index) => {
      if (!index) {
        this.cloneTabs[item] = true;
      }
    });

    this.handleSelectTab();
  },
  watch: {
    actionToAlterTab() {
      this.handleSelectTab();
    },
  },
};
</script>

<style scoped>
.contentTab {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.tabs {
  display: flex;
  gap: 10px;
  width: 100%;
  flex-wrap: wrap;
  align-items: center;
  background-color: rgb(179 178 176 / 35%);
  padding: 0.3rem;
  border-radius: 5px;
}

.customTabs {
  background-color: transparent;
  border: none;
  height: 25px;
  padding: 0 1rem;
  font-weight: 600;
  font-family: Poppins-Regular, sans-serif !important;
  color: #666360;
}

.newStyleTabs .tabs {
  border-bottom: none !important;
  background-color: rgb(0 58 93);
  margin-bottom: 10px;
    padding: 0.5rem;
}

.newStyleTabs .tabSelected {
  background-color: rgb(255, 255, 255);
  border: none !important;
  color: rgb(0 58 93) !important;
}

.newStyleTabs .customTabs {
  color: rgb(255, 255, 255);
  font-weight: normal !important;
}

.newStyleTabs .contentItem {
  background-color: rgb(241 238 238);
}

.newStyleTabs {
  padding: 0 0 1rem 0 !important;
  gap: 0 !important;
}

.tabSelected {
  /* color: rgba(84, 188, 233, 0.975);
  border-bottom: solid 3px rgba(63, 143, 178, 0.975); */
  background-color: white;
  border-radius: 5px;
  height: 25px;
  box-shadow: 0 1px 2px 1px #0000001c;
}
</style>